var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "686E9248-27D3-4443-BD76-9D4955B78FFE@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "22 105 133 105 133 44 22 44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01X---Onboarding",
    transform: "translate(-64.000000, -353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(19.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-2",
    transform: "translate(45.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 124,
    cy: 124,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-family",
    transform: "translate(46.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-74",
    strokeWidth: 2,
    points: "99 22 78 4.27435864e-15 57 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-75",
    strokeWidth: 2,
    fill: "#FFD67E",
    points: "0 127 156 127 156 22 0 22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 22,
    x2: 22,
    y2: 44,
    id: "Stroke-77"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    y1: 44,
    x2: 156,
    y2: 22,
    id: "Stroke-78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 105,
    x2: 0,
    y2: 127,
    id: "Stroke-79"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    y1: 105,
    x2: 156,
    y2: 127,
    id: "Stroke-80"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#17243D",
    strokeWidth: 2,
    d: "M134,43 L134,106 L21,106 L21,43 L134,43 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    mask: "url(#mask-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.666400, 61.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.284,26.1737333 C25.0746667,28.5830667 22.212,30.0004 19.1186667,30.0004 C16.0266667,30.0004 13.1626667,28.5830667 10.9546667,26.1737333 L6.66666667,27.6644 C2.64666667,29.0630667 0,33.8524 0,38.1097333 L0,49.3337333 L38.6666667,49.3337333 L38.6666667,38.1097333 C38.6666667,33.8524 35.5906667,29.0630667 31.5706667,27.6644 L27.284,26.1737333 Z",
    id: "Stroke-18",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(5.333600, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3333333,10.6666667 C25.3333333,4.684 19.816,0 13.8333333,0 C7.85066667,0 2.66666667,4.684 2.66666667,10.6666667 C2.66666667,11.4666667 2.50133333,12.5826667 2.66666667,13.3333333 C2.48933333,13.8626667 3,14.316 3,15 C3,16.8413333 3.74666667,18.3333333 4.66666667,18.3333333 C4.84,18.3333333 5.00266667,18.2653333 5.16,18.168 C6.384,23.1066667 9.79866667,26.6666667 13.8333333,26.6666667 C17.868,26.6666667 22.1093333,22.9386667 23.3333333,18 C23.4906667,18.0973333 23.6533333,18.1653333 23.8266667,18.1653333 C24.7466667,18.1653333 25.3333333,16.6746667 25.3333333,14.8333333 C25.3333333,14.1493333 25.2293333,13.5146667 25.0533333,12.9853333 C25.2173333,12.2346667 25.3333333,11.4666667 25.3333333,10.6666667 L25.3333333,10.6666667 Z",
    id: "Stroke-16",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666667,13.3333333 C2.66666667,13.3333333 9.33333333,10.9586667 9.33333333,5.33333333 C9.33333333,6.844 18.0413333,13.3333333 25.3333333,13.3333333",
    id: "Stroke-20",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.33333333,
    y1: 14.6666667,
    x2: 10.6666667,
    y2: 14.6666667,
    id: "Stroke-22",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.3333333,
    y1: 14.6666667,
    x2: 18.6666667,
    y2: 14.6666667,
    id: "Stroke-24",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666667,10.6666667 C2.66666667,13.4266667 1.82266667,19.5106667 0,21.3333333 C1.69333333,23.0266667 8,24.1666667 8,24.1666667",
    id: "Stroke-26",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333333,10.6666667 C25.3333333,13.4266667 26.1773333,19.5106667 28,21.3333333 C26.3066667,23.0266667 19.6666667,24.1666667 19.6666667,24.1666667",
    id: "Stroke-28",
    stroke: "#17243D",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-567",
    mask: "url(#mask-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.000000, 58.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6895601,28.205863 C27.291223,30.8228891 24.1803364,32.3624014 20.8203471,32.3624014 C17.4618062,32.3624014 14.3509196,30.8228891 11.9525824,28.205863 L7.29349389,30.5491659 C2.92695615,32.0684024 0,36.546457 0,41.170787 L0,52.5003 L41.9998655,52.5003 L41.9998655,41.170787 C41.9998655,36.546457 38.7108416,32.0684024 34.3443038,30.5491659 L29.6895601,28.205863 Z",
    id: "Stroke-553",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(8.689772, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6206108,11.5861698 C24.6206108,5.08777681 19.532834,0 13.034441,0 C4.64605409,0 0,5.08777681 0,11.5861698 C0,12.4551325 0.125999597,13.2893368 0.304136957,14.1047135 C0.112965156,14.6796771 0,15.3690542 0,16.1120174 C0,18.1120799 0.811031886,19.7326954 1.81033903,19.7326954 C1.99861429,19.7326954 2.00151083,19.6573853 2.17240684,19.5516615 C3.50191982,24.9160582 7.74680278,28.9654245 12.1292715,28.9654245 C16.5117402,28.9654245 21.118691,25.6401938 22.448204,20.2757971 C22.6191,20.3815209 22.6219965,20.1106942 22.8102718,20.1106942 C23.8095789,20.1106942 24.6206108,18.4900787 24.6206108,16.4900162 C24.6206108,15.747053 24.5076457,15.0576759 24.3164739,14.4827122 C24.4946112,13.6673355 24.6206108,12.4551325 24.6206108,11.5861698 L24.6206108,11.5861698 Z",
    id: "Stroke-551",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.724135612,14.4827122 L2.89654245,14.4827122 C2.89654245,14.4827122 3.04426611,8.68962735 4.34481367,8.68962735 C5.64536123,8.68962735 10.1378986,9.58321069 10.1378986,5.7930849 C10.1378986,7.4339762 14.7318149,10.1378986 20.2757971,10.1378986 C20.2757971,11.7223073 21.7240684,14.4827122 21.7240684,14.4827122 L23.8964752,14.4827122",
    id: "Stroke-555",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.24135612,
    y1: 15.9309835,
    x2: 8.68962735,
    y2: 15.9309835,
    id: "Stroke-557",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9309835,
    y1: 15.9309835,
    x2: 17.3792547,
    y2: 15.9309835,
    id: "Stroke-559",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17240684,19.5516615 C3.78433271,21.1635874 5.37453452,21.7240684 7.24135612,21.7240684 C9.10817773,21.7240684 10.2740361,20.2757971 12.3103054,20.2757971",
    id: "Stroke-561",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.448204,20.2757971 C20.8362781,21.887723 18.5219407,21.7240684 16.6551191,21.7240684 C14.7882975,21.7240684 14.3465748,20.2757971 12.3103054,20.2757971",
    id: "Stroke-563",
    stroke: "#17243D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5861698,
    y1: 24.6206108,
    x2: 13.034441,
    y2: 24.6206108,
    id: "Stroke-565",
    stroke: "#17243D",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-307",
    mask: "url(#mask-2)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.583217, 65.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9166667,23.3183333 C21.9846667,25.4265 19.4786667,26.6666667 16.772,26.6666667 C14.0665,26.6666667 11.5605,25.4265 9.6285,23.3183333 L5.87533333,25.206 C2.35783333,26.4298333 0,29.7466667 0,33.4706667 L0,44.8333333 L33.8333333,44.8356667 L33.8333333,33.7646667 C33.8333333,30.0395 31.4755,26.7238333 27.958,25.5 L23.9166667,23.3183333 Z",
    id: "Stroke-293",
    strokeWidth: 2,
    fill: "#25D086",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16678333,7.58333333 L8.16678333,9.33333333 C8.16678333,9.5865 8.18778333,9.90383333 8.16678333,9.90383333 C7.36178333,9.90383333 7.00011667,11.2221667 7.00011667,12.8333333 C7.00011667,14.4445 7.65345,15.75 8.45845,15.75 C8.60895,15.75 8.75011667,15.6916667 8.88661667,15.6076667 C9.95878333,19.9278333 13.2406167,23.3333333 16.77095,23.3333333 C20.3012833,23.3333333 23.8747833,20.5111667 24.94695,16.191 C25.08345,16.275 25.2246167,16.3333333 25.3751167,16.3333333 C26.1801167,16.3333333 26.83345,15.0278333 26.83345,13.4166667 C26.83345,11.8055 26.4717833,10.5 25.6667833,10.5 C25.6457833,10.5 25.6877833,10.4976667 25.6667833,10.5 C25.69245,10.2538333 25.6667833,9.5865 25.6667833,9.33333333 L25.6667833,7.58333333",
    id: "Stroke-299",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.83345,
    y1: 12.8333333,
    x2: 14.0001167,
    y2: 12.8333333,
    id: "Stroke-295",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.83345,
    y1: 12.8333333,
    x2: 21.0001167,
    y2: 12.8333333,
    id: "Stroke-297",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16678333,4.08333333 L8.16678333,7.58333333 C8.16678333,7.58333333 11.21995,9.33333333 16.9167833,9.33333333 C22.6136167,9.33333333 25.6667833,7.58333333 25.6667833,7.58333333 L25.6667833,2.33333333",
    id: "Stroke-303",
    strokeWidth: 1.5,
    fill: "#FFD67E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-301",
    strokeWidth: 1.5,
    fill: "#FFD67E",
    fillRule: "evenodd",
    points: "16.33345 -7.10542736e-15 4.66678333 3.5 17.5001167 4.66666667 29.1667833 1.16666667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-305",
    strokeWidth: 1.5,
    fill: "none",
    points: "29.1667833 1.16666667 29.1667833 7 28.0001167 9.33333333 29.1667833 12.8333333 30.33345 9.33333333 29.1667833 7"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 122,
    cy: 222,
    rx: 50,
    ry: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFamily);
export default __webpack_public_path__ + "static/media/add-family.5767dd5b2c3b51369f166c6600424913.svg";
export { ForwardRef as ReactComponent };